import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import MountainApp from './mountain/App';
import App from './mars/App';

if (window.location.hash === '#mountain') {
    ReactDOM.render(<MountainApp />, document.getElementById("root"));
} else {
    ReactDOM.render(<App />, document.getElementById("root"));
}

